import React, { Component, ErrorInfo, ReactNode } from "react";

interface Props {
    children: ReactNode;
    fallback?: ReactNode;
}

interface State {
    hasError: boolean;
    error?: Error;
}

/**
 * ErrorBoundary Component
 * Catches JavaScript errors in child components and displays a fallback UI
 */
class ErrorBoundary extends Component<Props, State> {
    public state: State = {
        hasError: false,
    };

    public static getDerivedStateFromError(error: Error): State {
        return { hasError: true, error };
    }

    public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
        console.error("ErrorBoundary caught an error:", error, errorInfo);

    /*
     * You can log the error to an error reporting service here
     * Example: logErrorToService(error, errorInfo);
     */
    }

    private handleReset = () => {
        this.setState({ hasError: false, error: undefined });
    };

    public render() {
        if (this.state.hasError) {
            if (this.props.fallback) {
                return this.props.fallback;
            }

            return (
                <div className="error-boundary">
                    <h2>Oops! Something went wrong</h2>
                    <p>We're sorry for the inconvenience. Please try refreshing the page.</p>
                    <button onClick={this.handleReset} className="error-boundary__reset">
                        Try Again
                    </button>
                    {process.env.NODE_ENV === "development" && this.state.error &&
            <details className="error-boundary__details">
                <summary>Error Details</summary>
                <pre>{this.state.error.toString()}</pre>
            </details>
                    }
                </div>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;